<template>
  <div>
    <v-snackbar
      v-model="alert.active"
      outlined
      color="success"
      :timeout="-1"
      >
      <div
        class="font-weight-medium d-flex align-center"
        style="gap: 12px"
        >
        <v-icon
          color="success"
          >
          mdi-check-circle
        </v-icon>

        <div>
          {{ alert.message }}
        </div>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          v-bind="attrs"
          @click="alert.active = false"
          >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-expansion-panels
      v-model="panel"
      flat
      outlined
      >
      <v-expansion-panel
        style="border: 1px solid #dedede"
        v-for="(cash, i) in cashRegisters"
        :key="i"
        >
        <v-expansion-panel-header>
          <div>
            <v-tooltip 
              color="primary"
              bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mt-n1 mr-1"
                  :color="color[cash.state]"
                  v-on="on"
                  v-bind="attrs"
                  >
                  {{ icon[cash.state] }}
                </v-icon>
              </template>

              <span>{{ translate[cash.state] }}</span>
            </v-tooltip>

            {{ (new Date(cash.createdAt)).toLocaleDateString() }}
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <div
            v-if="cash.payments && cash.payments.length"
            >
            <detail
              :cash="cash"
              @reload="reload"
              ></detail>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { CashRegisters, CashRegister } from '@/graphql/queries/cash_registers'

const Detail = () => import('./Detail')

export default {
  data: () => ({
    cashRegisters: [],
    icon: {
      pending: 'mdi-reload',
      closed: 'mdi-check-circle-outline',
      accepted: 'mdi-check-circle',
      rejected: 'mdi-close-circle',
    },
    color: {
      pending: 'warning',
      closed: 'info',
      accepted: 'success',
      rejected: 'error'
    },
    translate: {
      pending: 'En curso',
      closed: 'Pendiente aprobación',
      accepted: 'Aprobado',
      rejected: 'Rechazado',
    },
    panel: null,
    alert: {
      active: false,
      message: ''
    }
  }),

  watch: {
    panel (val) {
      if (val != null) {
        this.fetchCashRegister(this.cashRegisters[val], val)
      }
    }
  },

  created () {
    this.fetchCashRegisters()
  },

  methods: {
    reload () {
      this.fetchCashRegister(this.cashRegisters[this.panel], this.panel)

      this.alert = {
        active: true,
        message: 'Cierre de caja aprobado con éxito'
      }
    },

    fetchCashRegisters () {
      this.$apollo.query({
        query: CashRegisters,
        fetchPolicy: 'no-cache'
      }).then ( res => {
        this.cashRegisters = res.data.cashRegisters
      })
    },

    fetchCashRegister (cash, idx) {
      this.$apollo.query({
        query: CashRegister,
        variables: {
          id: cash.id
        },
        fetchPolicy: 'no-cache'
      }).then ( res => {
        cash.payments = res.data.cashRegister.payments
        cash.state = res.data.cashRegister.state

        this.$nextTick( () => {
          this.$forceUpdate()
        })
      })
    },

  },

  components: {
    Detail
  }
}
</script>
